import { FormControlLabel, FormGroup, Stack, Checkbox, Tooltip } from '@mui/material';
import { BaseFieldWrapper } from './BaseFieldWrapper';
import { CheckboxListProperties } from 'src/api/process-module';
import { Field } from 'src/API';

interface CheckboxListFieldProps {
  field: Field;
  value: { [key: string]: boolean };
  onChange: (value: { [key: string]: boolean }) => void;
  disabled?: boolean;
  fieldProps?: CheckboxListProperties;
}

export const CheckboxListField = ({ field, value, onChange, disabled = false, fieldProps }: CheckboxListFieldProps) => {
  const dataSource = (() => {
    const source = (field as any).properties?.dataSource || field.dataSource;
    if (!source) return [];
    try {
      return JSON.parse(source);
    } catch {
      return [];
    }
  })();

  const handleChange = (optionName: string, checked: boolean) => {
    onChange({
      ...(value || {}),
      [optionName]: checked,
    });
  };

  return (
    <BaseFieldWrapper label={field.label} required={fieldProps?.required} fieldProps={fieldProps}>
      <FormGroup>
        <Stack spacing={1}>
          {dataSource.map((option: { name: string; label: string }) => (
            // <Tooltip
            //   key={option.name}
            //   title={option.label}
            //   placement="right"
            //   arrow
            // >
            <FormControlLabel
              key={option.name}
              control={
                <Checkbox
                  checked={value?.[option.name] || false}
                  onChange={(e) => handleChange(option.name, e.target.checked)}
                  disabled={disabled}
                  color="primary"
                />
              }
              label={option.label}
              sx={{
                ml: 0,
                '& .MuiFormControlLabel-label': {
                  color: disabled ? 'text.disabled' : 'text.primary',
                },
              }}
            />
            // </Tooltip>
          ))}
        </Stack>
      </FormGroup>
    </BaseFieldWrapper>
  );
};
